__turbopack_context__.v({
  "deliverableTypesPanel": "_9P_vEa_deliverableTypesPanel",
  "deliverableTypesPanel__actionsCell": "_9P_vEa_deliverableTypesPanel__actionsCell",
  "deliverableTypesPanel__nameCell": "_9P_vEa_deliverableTypesPanel__nameCell",
  "modalCard": "_9P_vEa_modalCard",
  "modalCard__subtitle": "_9P_vEa_modalCard__subtitle",
  "modalCard__title": "_9P_vEa_modalCard__title",
});
